<!--16 Suchen per Liste-->
<dx-lookup placeholder="{{'SuchKriterium' | translate}}" [searchEnabled]="false" [items]="searchValues"   [(value)]="searchValue">
</dx-lookup>
<div class="dx-text-area-coloured w-100">
  <dx-text-area [value]="inputList" (onValueChanged)="onValueChangedFormatListIgnoreSpace($event)" [height]="400">
  </dx-text-area>
</div>
